export const activateTab = (id: string) => {
    if (typeof window === 'undefined') return;

    const isTabId = id.endsWith('-tab');
    const tabId = isTabId ? id : `${id}-tab`;
    const paneId = isTabId ? id.replace(/-tab$/, '') : id;

    const el =
        document.getElementById(tabId) ||
        document.querySelector(`[data-bs-target="#${paneId}"], [href="#${paneId}"]`);

    if (!el) return;

    const url = new URL(window.location.href);
    url.searchParams.set('activeTab', tabId);
    window.history.pushState({}, '', url);

    (el as HTMLElement).click();
};
